import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../../service/utils.service';
import { GlobalConfig } from '../../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ConformMessageComponent } from '../../../conform-message/conform-message/conform-message.component';

@Component({
  selector: 'app-districts',
  templateUrl: './districts.component.html',
  styleUrls: ['./districts.component.css']
})
export class DistrictsComponent implements OnInit {
  isList: Boolean = true;
  constructor(
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private modalService: BsModalService,
  ) { }
  bsModalRef: BsModalRef;
  totalItems: any = Number;
  district: any[] = [];
  districtsIds: any[] = [];
  checkAll: Boolean = false;
  page: any = { pageNumber: 1, pageSize: 20, districtsName: '' };
  ngOnInit() {
    this.getdistrictsAsync();
  }

  getdistrictsAsync() {
    this.servicesComponent.getdistrictsAsync(this.page)
      .then((response: any) => {
        if (response.success) {
          this.district = response.receiveObj.result.data;
          this.totalItems = response.receiveObj.result.total_rows;
          this.isList = this.district.length > 0 ? true : false;
        } 
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  pageChanged(event: any): void {
    this.page.pageNumber = event.page;
    this.page.pageSize = event.itemsPerPage;
    this.getdistrictsAsync();
  }

  searchDistrict() {
    this.page.pageNumber = 1;
    this.getdistrictsAsync();
  }

  updateDistrict(id) {
    this.router.navigate(['./saveDistricts', id]);
  }

  enableDisableDistrict(isEnable) {
    const districtIdsValue = [];
    this.district.forEach(function (value) {
      if (value.isDisable === true) {
        districtIdsValue.push({ id: value.id, isEnable: isEnable });
      }
    });

    this.districtsIds = districtIdsValue;
    if (this.districtsIds.length > 0) {
      this.result();
    }
  }

  disableSingle(id, isEnable) {
    const districtIdsValue = [];
    this.districtsIds = [];
    districtIdsValue.push({ id: id, isEnable: isEnable });
    this.districtsIds = districtIdsValue;
    this.result();
  }

  selectAllCheckBox() {
    this.districtsIds = [];
    const citiesIdsValue = [];
    if (!this.checkAll) {
      this.district.forEach(function (value) {
        value.isDisable = true;
      });
    }

    else {
      this.districtsIds = [];
      this.district.forEach(function (value) {
        value.isDisable = false;
      });
    }
  }

  callMessgaeConform(id: any) {
    const subject = new Subject<any>();
    this.config.confirmService = { confirmMessage: 'Do you want to delete the district?' };
    this.bsModalRef = this.modalService.show(ConformMessageComponent);
    this.bsModalRef.content.subject = subject;
    subject.asObservable().subscribe((data) => {
      if (data) {
        this.delete(id);
      }
      this.bsModalRef.hide();
    });
  }

  delete(id) {
    if (id > 0) {
      this.servicesComponent.deleteDistrict(id)
        .then((response: any) => {
          if (response.success == true) {
            this.page.pageNumber = 1;
            this.getdistrictsAsync();
            this.toastr.success('district delete successfully.', 'Success!');
          } else {
            this.toastr.error('Some error occured, Please contact admin.', 'Error!');
          }
        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    }
  }

  result() {
    this.servicesComponent.enableDisableDistrict(this.districtsIds)
      .then((response: any) => {
        if (response.success == true) {
          this.page.pageNumber = 1;
          this.getdistrictsAsync();
          this.toastr.success('district enabil / disable successfully.', 'Success!');
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/areasManagement/district/districts/districts.component.ts